import React from 'react';
import './Button.css';

/* Botón del sistema de diseño (refactor UI F2) — jerarquía fija del ESTANDAR §6:
   · primary:     LA acción principal de la pantalla/pestaña (solo UNO visible).
   · secondary:   exportar, imprimir, configurar, importar.
   · tertiary:    acción de texto/ícono sin superficie dominante.
   · destructive: eliminar/anular/cancelar — SIEMPRE rojo; la CONFIRMACIÓN es
     responsabilidad del caller (ConfirmDialog), no de este componente.
   "Registrar egreso" y demás operaciones financieras normales NUNCA son
   destructive (criterio 15 del brief). */
export default function Button({
  variant = 'secondary',
  size = 'md',            // 'md' (control estándar 44px) | 'sm' (36px, toolbars)
  icon = null,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={`ui-btn ui-btn--${variant} ui-btn--${size}${loading ? ' ui-btn--loading' : ''}${className ? ` ${className}` : ''}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="ui-btn-spinner" aria-hidden="true" />}
      {icon && !loading && <span className="ui-btn-icon" aria-hidden="true">{icon}</span>}
      {children != null && <span className="ui-btn-label">{children}</span>}
    </button>
  );
}
